import Modal from './Modals/Modal';
import ModalsProvider, { ModalsRenderer } from './ModalsProvider';
import useModals from './useModals';

export { Modal, ModalsProvider, ModalsRenderer };
export default useModals;
